import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogoGoTix, SpinnerBtn } from '../util/CustomIcons';
import { MdOutlineArrowForward } from 'react-icons/md';
import { useUserDetails } from '../../hooks/user/useUserDetails';
import useDecodedToken from '../../hooks/useDecodedToken';

export default function FooterLandingPage({ lightFooter }) {
  let [isLoading, setIsLoading] = useState(false);
  // const [formValues, setFormValues] = useState({ email: '' });
  const decodedToken = useDecodedToken();
  const navigate = useNavigate();
  const {
    // subscribeToNewsLetter,
    userdetails: { data },
    // refetch,
  } = useUserDetails(decodedToken?.username);
  // const [form] = Form.useForm();
  // const [newsletterMessage, setNewsletterMessage] = useState({
  //   status: null,
  //   message: '',
  // });

  // useEffect(() => {
  //   form.setFieldsValue(formValues);
  // }, [form, formValues]);
  return (
    <React.Fragment>
      {/* <div
        className={`${
          lightFooter ? 'bg-gray-100' : 'bg-neutral-900'
        } w-full footer_new lg:h-96 flex justify-center items-center`}
      >
        <div className="container py-10">
          <div className="flex flex-col items-center w-full space-y-10">
            <div className="text-6xl w-full max-w-md flex justify-center">
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 419 114"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                // className="w-full text-neutral-700"
                className={`${
                  lightFooter ? 'text-neutral-500' : 'text-neutral-700'
                } w-full`}
              >
                <path
                  d="M36.21 25.78C43.07 25.78 48.53 28.02 52.59 32.5C56.72 36.91 58.785 43 58.785 50.77V85H40.935V53.185C40.935 49.265 39.92 46.22 37.89 44.05C35.86 41.88 33.13 40.795 29.7 40.795C26.27 40.795 23.54 41.88 21.51 44.05C19.48 46.22 18.465 49.265 18.465 53.185V85H0.51V26.41H18.465V34.18C20.285 31.59 22.735 29.56 25.815 28.09C28.895 26.55 32.36 25.78 36.21 25.78ZM100.662 41.32H91.002V85H73.047V41.32H66.537V26.41H73.047V24.73C73.047 17.52 75.112 12.06 79.242 8.35C83.372 4.57 89.427 2.68 97.407 2.68C98.737 2.68 99.717 2.715 100.347 2.78499V18.01C96.917 17.8 94.502 18.29 93.102 19.48C91.702 20.67 91.002 22.805 91.002 25.885V26.41H100.662V41.32ZM141.754 69.775V85H132.619C126.109 85 121.034 83.425 117.394 80.275C113.754 77.055 111.934 71.84 111.934 64.63V41.32H104.794V26.41H111.934V12.13H129.889V26.41H141.649V41.32H129.889V64.84C129.889 66.59 130.309 67.85 131.149 68.62C131.989 69.39 133.389 69.775 135.349 69.775H141.754ZM174.015 25.57C178.145 25.57 181.75 26.41 184.83 28.09C187.98 29.77 190.395 31.975 192.075 34.705V26.41H210.03V84.895C210.03 90.285 208.945 95.15 206.775 99.49C204.675 103.9 201.42 107.4 197.01 109.99C192.67 112.58 187.245 113.875 180.735 113.875C172.055 113.875 165.02 111.81 159.63 107.68C154.24 103.62 151.16 98.09 150.39 91.09H168.135C168.695 93.33 170.025 95.08 172.125 96.34C174.225 97.67 176.815 98.335 179.895 98.335C183.605 98.335 186.545 97.25 188.715 95.08C190.955 92.98 192.075 89.585 192.075 84.895V76.6C190.325 79.33 187.91 81.57 184.83 83.32C181.75 85 178.145 85.84 174.015 85.84C169.185 85.84 164.81 84.615 160.89 82.165C156.97 79.645 153.855 76.11 151.545 71.56C149.305 66.94 148.185 61.62 148.185 55.6C148.185 49.58 149.305 44.295 151.545 39.745C153.855 35.195 156.97 31.695 160.89 29.245C164.81 26.795 169.185 25.57 174.015 25.57ZM192.075 55.705C192.075 51.225 190.815 47.69 188.295 45.1C185.845 42.51 182.835 41.215 179.265 41.215C175.695 41.215 172.65 42.51 170.13 45.1C167.68 47.62 166.455 51.12 166.455 55.6C166.455 60.08 167.68 63.65 170.13 66.31C172.65 68.9 175.695 70.195 179.265 70.195C182.835 70.195 185.845 68.9 188.295 66.31C190.815 63.72 192.075 60.185 192.075 55.705ZM249.69 85.84C243.95 85.84 238.77 84.615 234.15 82.165C229.6 79.715 225.995 76.215 223.335 71.665C220.745 67.115 219.45 61.795 219.45 55.705C219.45 49.685 220.78 44.4 223.44 39.85C226.1 35.23 229.74 31.695 234.36 29.245C238.98 26.795 244.16 25.57 249.9 25.57C255.64 25.57 260.82 26.795 265.44 29.245C270.06 31.695 273.7 35.23 276.36 39.85C279.02 44.4 280.35 49.685 280.35 55.705C280.35 61.725 278.985 67.045 276.255 71.665C273.595 76.215 269.92 79.715 265.23 82.165C260.61 84.615 255.43 85.84 249.69 85.84ZM249.69 70.3C253.12 70.3 256.025 69.04 258.405 66.52C260.855 64 262.08 60.395 262.08 55.705C262.08 51.015 260.89 47.41 258.51 44.89C256.2 42.37 253.33 41.11 249.9 41.11C246.4 41.11 243.495 42.37 241.185 44.89C238.875 47.34 237.72 50.945 237.72 55.705C237.72 60.395 238.84 64 241.08 66.52C243.39 69.04 246.26 70.3 249.69 70.3ZM322.53 69.775V85H313.395C306.885 85 301.81 83.425 298.17 80.275C294.53 77.055 292.71 71.84 292.71 64.63V41.32H285.57V26.41H292.71V12.13H310.665V26.41H322.425V41.32H310.665V64.84C310.665 66.59 311.085 67.85 311.925 68.62C312.765 69.39 314.165 69.775 316.125 69.775H322.53ZM341.561 20.32C338.411 20.32 335.821 19.41 333.791 17.59C331.831 15.7 330.851 13.39 330.851 10.66C330.851 7.86 331.831 5.55 333.791 3.72999C335.821 1.83999 338.411 0.894994 341.561 0.894994C344.641 0.894994 347.161 1.83999 349.121 3.72999C351.151 5.55 352.166 7.86 352.166 10.66C352.166 13.39 351.151 15.7 349.121 17.59C347.161 19.41 344.641 20.32 341.561 20.32ZM350.486 26.41V85H332.531V26.41H350.486ZM398.148 85L386.913 68.725L377.463 85H358.038L377.358 55.075L357.513 26.41H377.673L388.908 42.58L398.358 26.41H417.783L398.148 55.915L418.308 85H398.148Z"
                  fill="currentColor"
                  // fillOpacity="0.06"
                />
              </svg>
            </div>
            <div className="flex justify-between w-full max-w-md">
              <span className="flex flex-col justify-center items-center gap-2">
                <span
                  className={`${
                    lightFooter ? 'border-neutral-700' : ''
                  } flex w-10 h-10 border-2 rounded-full border-1 relative p-2`}
                >
                  <RiFacebookFill
                    // className="text-white w-full h-full"
                    className={`${
                      lightFooter ? 'text-neutral-800' : 'text-whiteNew-0'
                    } w-full h-full`}
                  />
                </span>
                <span
                  className={`${
                    lightFooter ? 'text-neutral-800' : 'text-gray-50'
                  }`}
                >
                  Facebook
                </span>
              </span>
              <span className="flex flex-col justify-center items-center gap-2">
                <span
                  className={`${
                    lightFooter ? 'border-neutral-700' : ''
                  } flex w-10 h-10 border-2 rounded-full border-1 relative p-2`}
                >
                  <AiOutlineInstagram
                    className={`${
                      lightFooter ? 'text-neutral-800' : 'text-whiteNew-0'
                    } w-full h-full`}
                  />
                </span>
                <span
                  className={`${
                    lightFooter ? 'text-neutral-800' : 'text-gray-50'
                  }`}
                >
                  Instagram
                </span>
              </span>
              <span className="flex flex-col justify-center items-center gap-2">
                <span
                  className={`${
                    lightFooter ? 'border-neutral-700' : ''
                  } flex w-10 h-10 border-2 rounded-full border-1 relative p-2`}
                >
                  <FaLinkedinIn
                    className={`${
                      lightFooter ? 'text-neutral-800' : 'text-whiteNew-0'
                    } w-full h-full`}
                  />
                </span>
                <span
                  className={`${
                    lightFooter ? 'text-neutral-800' : 'text-gray-50'
                  }`}
                >
                  Linkedin
                </span>
              </span>
              <span className="flex flex-col justify-center items-center gap-2">
                <span
                  className={`${
                    lightFooter ? 'border-neutral-700' : ''
                  } flex w-10 h-10 border-2 rounded-full border-1 relative p-2`}
                >
                  <AiOutlineTwitter
                    className={`${
                      lightFooter ? 'text-neutral-800' : 'text-whiteNew-0'
                    } w-full h-full`}
                  />
                </span>
                <span
                  className={`${
                    lightFooter ? 'text-neutral-800' : 'text-gray-50'
                  }`}
                >
                  Twitter
                </span>
              </span>
            </div>
            <div className="w-full">
              {lightFooter ? (
                <>
                  <div
                    className="bg-gray-400 w-full"
                    style={{ height: '1px' }}
                  ></div>
                </>
              ) : (
                <>
                  <svg
                    width="1em"
                    height="2"
                    viewBox="0 0 1632 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full"
                  >
                    <line
                      y1="1"
                      x2="1632"
                      y2="1"
                      stroke="url(#paint0_linear_4289_1647)"
                      strokeWidth="2"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_4289_1647"
                        x1="1652"
                        y1="3.08267"
                        x2="62"
                        y2="3.08267"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopOpacity="0" />
                        <stop offset="0.463542" stopColor="white" />
                        <stop offset="0.671875" stopColor="white" />
                        <stop offset="1" stopOpacity="0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </>
              )}
            </div>
            <div className="flex justify-center w-full max-w-md gap-3">
              <span className="">
                <Link
                  to="/"
                  className={`${
                    lightFooter ? 'text-sky-600' : 'text-landingPurple-60'
                  } font-medium duration-300 ease-in`}
                >
                  ©2023 NFTGOTIX
                </Link>
              </span>
              <div>
                <span
                  className="flex h-full bg-gray-500"
                  style={{ width: '1px' }}
                ></span>
              </div>
              <span className="">
                <Link
                  to="/privacy-policy"
                  className={`${
                    lightFooter ? 'text-neutral-800' : 'text-gray-300'
                  }  font-light hover:underline duration-300 ease-in`}
                >
                  Privacy Policy
                </Link>
              </span>
              <div>
                <span
                  className="flex h-full bg-gray-500"
                  style={{ width: '1px' }}
                ></span>
              </div>
              <span className="">
                <Link
                  to="/terms-of-use"
                  className={`${
                    lightFooter ? 'text-neutral-800' : 'text-gray-300'
                  }  font-light hover:underline duration-300 ease-in`}
                >
                  Terms Of Use
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className={lightFooter ? 'theme-light' : ''}> */}
      <div>
        <footer
          // className="footer pt-5 pb-5"
          className={`footer bg-lightTheme-70 dark:bg-color-base-header-1 w-full footer_new flex justify-center items-center`}
        >
          <div className="container-fluid px-2.5 lg:px-11 max-w-[1800px] py-7 relative">
            <div className="row items-center">
              <div className="flex flex-col lg:flex-row justify-between gap-3 lg:gap-0">
                <h4 className="heading text-sky-600 dark:text-color-primaryColor1 font-bold text-3xl">
                  FOLLOW US
                </h4>

                <div className="sm:absolute top-6 right-7">
                  {!data?.subscribeNewsletterData?.filter(
                    (data) => data?.type === 'early_access',
                  )?.[0]?.status && (
                    <div
                      className={`flex ${
                        decodedToken?.id
                          ? 'flex-col gap-2 sm:items-end sm:justify-end'
                          : 'flex-col items-start lg:items-end'
                      } mb-2`}
                    >
                      <div
                        className={`flex ${
                          // decodedToken?.id
                          'flex-col sm:flex-row items-start sm:items-center gap-2'
                          // 'flex-col sm:items-end gap-1'
                        } `}
                      >
                        <h3 className="text-sm font-normal mb-0">
                          {!decodedToken?.id && (
                            // <span>
                            //   Get an early access to unpack a new era of events
                            // </span>
                            <span>Unpack a new era of events</span>
                          )}
                          {/* {decodedToken?.id && (
                            <span>Unpack a new era of events</span>
                          )} */}
                        </h3>
                        {/* {decodedToken?.id ? ( */}
                        {!decodedToken?.id && (
                          <button
                            type="button"
                            className="flex flex-row items-center justify-center bg-gradient-to-r from-color-primaryColor1 to-color-primaryColor2 text-whiteNew-0 px-3.5 py-2.5 rounded-md text-sm gap-2"
                            onClick={async () => {
                              setIsLoading(true);
                              navigate('/user/signup');
                              // const res = await subscribeToNewsLetter(
                              //   decodedToken.email,
                              //   'early_access',
                              // );
                              // if (res?.status) {
                              //   setIsLoading(false);
                              //   setNewsletterMessage({
                              //     status: res?.status,
                              //     message: res?.message,
                              //   });
                              //   setTimeout(() => {
                              //     refetch();
                              //     setNewsletterMessage({
                              //       status: null,
                              //       message: '',
                              //     });
                              //   }, 2000);
                              // } else {
                              //   setIsLoading(false);
                              //   setNewsletterMessage({
                              //     status: res?.status,
                              //     message:
                              //       'You’re already subscribed for the early access!',
                              //   });
                              //   setTimeout(() => {
                              //     refetch();
                              //     setNewsletterMessage({
                              //       status: null,
                              //       message: '',
                              //     });
                              //   }, 2000);
                              // }
                            }}
                          >
                            <span className="ps-1">Get early access</span>
                            {isLoading ? (
                              <SpinnerBtn className={'text-sm'}></SpinnerBtn>
                            ) : (
                              <MdOutlineArrowForward className="text-base" />
                            )}
                          </button>
                        )}
                        {/* ) : (
                          <Form
                            form={form}
                            layout="vertical"
                            name="form_in_modal"
                            initialValues={formValues}
                            onFinish={async () => {
                              setIsLoading(true);
                              const res = await subscribeToNewsLetter(
                                formValues.email,
                                'early_access',
                              );
                              if (res?.status) {
                                setIsLoading(false);
                                setNewsletterMessage({
                                  status: res?.status,
                                  message: res?.message,
                                });
                                setTimeout(() => {
                                  // refetch();
                                  setNewsletterMessage({
                                    status: null,
                                    message: '',
                                  });
                                }, 2000);
                              } else {
                                setIsLoading(false);
                                setNewsletterMessage({
                                  status: res?.status,
                                  message:
                                    'You’re already subscribed for the early access!',
                                });
                                setTimeout(() => {
                                  // refetch();
                                  setNewsletterMessage({
                                    status: null,
                                    message: '',
                                  });
                                }, 2000);
                              }
                              setFormValues({ email: '' });
                              form.resetFields();
                            }}
                          >
                            <div className="flex flex-row gap-2 mt-2">
                              <Form.Item
                                name="email"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Email is required!',
                                  },
                                  {
                                    pattern: EMAIL_REG,
                                    message: 'Invalid email',
                                  },
                                ]}
                                className="max-w-[200px]  mb-[0]"
                              >
                                <Input
                                  className="max-w-[200px] dark:bg-zinc-800 dark:border-zinc-700 dark:text-zinc-200 dark:placeholder:text-zinc-500 placeholder:font-medium mb-[5px]"
                                  placeholder="Enter your Email"
                                  name="email"
                                  onChange={(e) => {
                                    let obj = {
                                      ...formValues,
                                      email: e.target.value,
                                    };
                                    form.setFieldValue('email', e.target.value);
                                    setFormValues(obj);
                                  }}
                                />
                              </Form.Item>
                              <Form.Item style={{ marginBottom: 0 }}>
                                <button
                                  type="submit"
                                  className="bg-gradient-to-r from-color-primaryColor1 to-color-primaryColor2 text-whiteNew-0 px-[8px] py-[8px] rounded-md text-sm"
                                >
                                  {isLoading ? (
                                    <SpinnerBtn
                                      className={'text-sm'}
                                    ></SpinnerBtn>
                                  ) : (
                                    <MdOutlineArrowForward className="text-base" />
                                  )}
                                </button>
                              </Form.Item>
                            </div>
                          </Form>
                        )} */}
                      </div>
                      {/* <div>
                        {newsletterMessage?.status !== null && (
                          <span
                            className={`${
                              newsletterMessage?.status
                                ? 'text-green-500 dark:text-green-600'
                                : 'text-red-500 dark:text-red-600'
                            } rounded-md flex flex-row justify-between text-left lg:text-right`}
                          >
                            {newsletterMessage?.message}
                          </span>
                        )}
                      </div> */}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-8 col-xl-7 flex flex-col lg:flex-row justify-between w-full">
                <div className="flex flex-col">
                  <ul className="socialLinks">
                    <li>
                      <a
                        className="dark:mobileBrdr dark:text-white text-zinc-900"
                        href="/#"
                        // target="_blank"
                        rel="noopener noreferrer"
                      >
                        Instagram
                      </a>
                    </li>
                    <li>
                      <a
                        className="dark:mobileBrdr dark:text-white text-zinc-900"
                        href="/#"
                        // target="_blank"
                        rel="noopener noreferrer"
                      >
                        Twitter
                      </a>
                    </li>
                    <li>
                      <a
                        className="dark:mobileBrdr dark:text-white text-zinc-900"
                        href="/#"
                        // target="_blank"
                        rel="noopener noreferrer"
                      >
                        Discord
                      </a>
                    </li>
                    <li>
                      <a
                        className="dark:mobileBrdr dark:text-white text-zinc-900"
                        href="/#"
                        // target="_blank"
                        rel="noopener noreferrer"
                      >
                        Telegram
                      </a>
                    </li>
                    <li>
                      <a
                        className="dark:mobileBrdr dark:text-white text-zinc-900"
                        href="/#"
                        // target="_blank"
                        rel="noopener noreferrer"
                      >
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a
                        className="dark:mobileBrdr dark:text-white text-zinc-900"
                        href="/#"
                        // target="_blank"
                        rel="noopener noreferrer"
                      >
                        Tiktok
                      </a>
                    </li>
                  </ul>
                  <ul className="flex flex-row gap-4">
                    <li>
                      <a
                        href="/#"
                        rel="noopener noreferrer"
                        className="text-sky-600 dark:text-color-primaryColor1 font-extrabold"
                      >
                        &#169; 2023 NFTGOTIX
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/terms-of-use"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dark:text-whiteNew-0 text-zinc-900"
                      >
                        Terms of Use
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dark:text-whiteNew-0 text-zinc-900"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="flex items-end justify-start lg:justify-end w-full mt-[15px] lg:mt-[0px]">
                  <LogoGoTix
                    className={`${
                      lightFooter ? 'text-gray-600' : 'text-gray-600'
                    } h-8 w-40`}
                  />
                  {/* <Link to="/">hello</Link> */}
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
}
